import { InputProps } from './Input.types';
import exclamationIcon from '../../../assets/exclamation.svg';

export function Input({
  label,
  id,
  type = 'text',
  placeholder,
  required,
  value,
  maxLength,
  onChange,
  onBlur,
  containerClassName = 'flex flex-col items-start gap-2 self-stretch',
  labelClassName,
  inputClassName,
  children,
  disabled = false,
  error,
  displayError = true,
  icon,
  preventSpacing
}: InputProps) {
  const errorMessage =
    error && displayError ? (
      <div className="flex items-center mt-1 text-red-900">
        <img src={exclamationIcon} alt="Exclamation" />
        <span className="ml-2">{error}</span>
      </div>
    ) : (
      ''
    );

  return children ? (
    <div className="flex flex-col text-left gap-1">
      <label htmlFor={id} className={labelClassName}>
        {label}
      </label>
      <div className="relative">
        <input
          id={id}
          type={type}
          placeholder={placeholder}
          className={`${inputClassName}
            ${
              disabled
                ? 'bg-gray-100 text-gray-900 border-gray-200 shadow-sm cursor-not-allowed'
                : error
                  ? 'border-rose-400 text-rose-800 focus:ring-rose-700 hover:border-rose-400'
                  : 'border-gray-300 text-gray-900 focus:ring-purple-800'
            }`}
          required={required}
          value={value}
          maxLength={maxLength}
          onChange={onChange}
          onKeyDown={(e) =>
            preventSpacing && e.key === ' ' && e.preventDefault()
          }
          onBlur={onBlur}
          disabled={disabled}
        />
        {children}
      </div>
      {errorMessage}
    </div>
  ) : (
    <div className={containerClassName}>
      <label htmlFor={id} className={labelClassName}>
        {label}
      </label>
      <div className="relative w-full">
        {icon && (
          <div className="absolute inset-y-0 left-3 flex items-center pointer-events-none">
            {icon}
          </div>
        )}
        <input
          id={id}
          type={type}
          placeholder={placeholder}
          className={`${inputClassName}
            ${
              error
                ? 'border-rose-400 text-rose-800 focus:ring-red-500 hover:border-rose-400'
                : 'border-gray-300 text-gray-900 focus:ring-purple-800'
            }
            ${icon ? 'pl-9' : ''}
            `}
          required={required}
          value={value}
          maxLength={maxLength}
          onChange={onChange}
          onBlur={onBlur}
          disabled={disabled}
        />
      </div>
      {errorMessage}
    </div>
  );
}
